<template>
  <div class="fontsize-dropdown" ref="dropdown">
    <button 
      class="fontsize-bbl-dropdown-trigger"
      @click="toggleDropdown"
      :class="{ 'is-open': isOpen }"
    >
      <span class="fontsize-preview">
        {{ currentLabel }}
      </span>
      <svg class="dropdown-icon" :class="{ 'rotate': isOpen }" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    
    <transition name="dropdown-fade">
      <div v-if="isOpen" class="fontsize-bbl-dropdown-menu">
        <div class="bbl-dropdown-menu-inner">
          <button
            v-for="option in options"
            :key="option.value"
            class="fontsize-option"
            :class="{ 'is-active': currentValue === option.value }"
            @click="selectOption(option)"
          >
            <span class="option-label">{{ option.label }}</span>
            <span class="option-preview" :style="{ fontSize: option.previewSize }">
              Aa
            </span>
            <svg v-if="currentValue === option.value" class="check-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M13.5 4L6 11.5L2.5 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FontSizeDropdown',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      isOpen: false,
      options: [
        { value: '', label: 'Default', previewSize: '14px' },
        { value: '8px', label: '8px', previewSize: '8px' },
        { value: '9px', label: '9px', previewSize: '9px' },
        { value: '10px', label: '10px', previewSize: '10px' },
        { value: '11px', label: '11px', previewSize: '11px' },
        { value: '12px', label: '12px', previewSize: '12px' },
        { value: '14px', label: '14px (H6)', previewSize: '14px' },
        { value: '16px', label: '16px (H5)', previewSize: '16px' },
        { value: '18px', label: '18px (H4)', previewSize: '18px' },
        { value: '20px', label: '20px (H3)', previewSize: '20px' },
        { value: '22px', label: '22px', previewSize: '22px' },
        { value: '24px', label: '24px (H2)', previewSize: '24px' },
        { value: '26px', label: '26px', previewSize: '26px' },
        { value: '28px', label: '28px', previewSize: '28px' },
        { value: '30px', label: '30px', previewSize: '30px' },
        { value: '32px', label: '32px (H1)', previewSize: '32px' },
        { value: '36px', label: '36px', previewSize: '36px' },
        { value: '40px', label: '40px', previewSize: '40px' },
        { value: '48px', label: '48px', previewSize: '48px' },
        { value: '56px', label: '56px', previewSize: '56px' },
        { value: '64px', label: '64px', previewSize: '64px' },
        { value: '72px', label: '72px', previewSize: '72px' }
      ]
    }
  },
  computed: {
    currentValue() {
      return this.modelValue || ''
    },
    currentLabel() {
      const option = this.options.find(opt => opt.value === this.currentValue)
      return option ? option.label : 'Default'
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    selectOption(option) {
      this.$emit('update:modelValue', option.value)
      this.$emit('change', { target: { value: option.value } })
      this.isOpen = false
    },
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style scoped>
.fontsize-dropdown {
  position: relative;
  display: inline-block;
}

.fontsize-bbl-dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1.5px solid #e5e7eb;
  border-radius: 6px;
  padding: 6px 12px;
  min-width: 110px;
  height: 32px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.fontsize-bbl-dropdown-trigger:hover {
  border-color: #3b82f6;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.fontsize-bbl-dropdown-trigger.is-open {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: white;
}

.fontsize-preview {
  flex: 1;
  text-align: left;
  font-weight: 500;
}

.dropdown-icon {
  color: #6b7280;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.dropdown-icon.rotate {
  transform: rotate(180deg);
}

.fontsize-bbl-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 200px;
  background: white;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  overflow: hidden;
}

.bbl-dropdown-menu-inner {
  padding: 6px;
  max-height: 360px;
  overflow-y: auto;
}

.fontsize-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
  color: #374151;
  font-weight: 400;
}

.fontsize-option:hover {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
}

.fontsize-option.is-active {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
  font-weight: 500;
}

.option-label {
  flex: 1;
  font-size: 13px;
}

.option-preview {
  font-weight: 600;
  color: #6b7280;
  line-height: 1;
  min-width: 30px;
  text-align: center;
}

.fontsize-option.is-active .option-preview {
  color: #1e40af;
}

.check-icon {
  color: #3b82f6;
  flex-shrink: 0;
}

/* Dropdown animation */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-fade-enter-from {
  opacity: 0;
  transform: translateY(-8px) scale(0.95);
}

.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px) scale(0.98);
}

/* Scrollbar styling */
.bbl-dropdown-menu-inner::-webkit-scrollbar {
  width: 6px;
}

.bbl-dropdown-menu-inner::-webkit-scrollbar-track {
  background: transparent;
}

.bbl-dropdown-menu-inner::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.bbl-dropdown-menu-inner::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}
</style>
